import GroupInfoFormValidation from "@usas/ui-web/components/forms/groups/GroupInfoFormValidation";
import PracticeAttributesFormValidation from "@usas/ui-web/components/forms/groups/PracticeAttributesFormValidation";

const ClubGroupTypePracticeValidation = async (formState) => {
  let errors = {
    ...GroupInfoFormValidation(formState),
    ...PracticeAttributesFormValidation(formState)
  };

  return errors ? errors : {};
};

export default ClubGroupTypePracticeValidation;